<template>
  <el-main>
    <el-row>    
      成绩报表:项目=>{{ sel_xm }}{{ ' ' }}科目=>{{ sel_kemu }}      
    </el-row>
    <el-row>
    
      
        <el-tabs v-model="activeName" type="border-card"    @tab-click="handleClick" >
          
              <el-tab-pane v-for="(item, index) in kemulist"  :name="index" :label="item" ></el-tab-pane>      
              <el-row v-show="zongfenshow">
                <vxe-input v-model="filterName2" type="search" placeholder="输入考号或者姓名" @keyup="searchEvent2"></vxe-input>
                <vxe-button @click="exportzfdata">导出总成绩</vxe-button> 
                <vxe-button @click="zfbaobiao">总分报表</vxe-button> 
              <vxe-table
                        border                        
                        ref="xTable"
                        height="400"
                        :row-config="{height: 20,isCurrent: true, isHover: true}"
                        :loading="loading"
                        :column-config="{resizable: true}"
                        :seq-config="{startIndex: 0}"
                        :data="items"
                        :scroll-x="{enabled: true}"
                        :scroll-y="{enabled: true}"
                        > 
                        <vxe-column type="seq" title="序号"   width="60"></vxe-column>
                        <vxe-column
                          v-for="config in fields"
                          :key="config.key"
                          :type="config.type"
                          :field="config.field"
                          :title="config.title"
                        
                   
                          sortable>
                        </vxe-column>
                </vxe-table>
                总数:{{totalRows}} 
               
              </el-row>

              <el-row v-show="dankeshow">
                
                <vxe-input v-model="filterName1" type="search" placeholder="输入考号或者姓名" @keyup="searchEvent1"></vxe-input>
                <vxe-button @click="exportdankedata">导出{{ this.sel_kemu }}成绩</vxe-button> 
              <vxe-table
                        border                        
                        ref="xTabledanke"
                        height="400"
                        :row-config="{height: 20,isCurrent: true, isHover: true}"
                        :loading="loading"
                        :column-config="{resizable: true}"
                        :seq-config="{startIndex: 0}"
                        :data="dankescore"
                        :scroll-y="{enabled: true}"
                        :scroll-x="{enabled: true}"
                        show-overflow
                        > 
                        <vxe-column type="seq" title="序号"  width="60"></vxe-column>
                        <vxe-column
                          width="80"
                          v-for="config in tizus"    
                          :key="config.field"                    
                          :field="config.field"
                          :title="config.tihao"
                          :width="config.width"
                          
                          sortable>
                        </vxe-column>
                </vxe-table>
                总数:{{danketotalRows}}
                
               
              </el-row>
        </el-tabs>
       
      
    </el-row>

  </el-main>
</template>
<script>
	import axios from 'axios'
	import qs from 'qs'
	import localStorage from 'localStorage'
  import ExcelJS from 'exceljs'
  import XEUtils from 'xe-utils'

	export default {
		data() {
		  return {
			kemulist: [],
      activeName: '0',
			defaultProps: {
			   children: 'children',
						label: 'label',
						level: 'level'
					},
				sel_xm:'',
        sel_kemu:'',
        sel_School:'',
        sel_tizu:'',
        is_disable:true,
				is_jindu_disable:true,
				options:[],
				cascagerdefault: ["0", "0", ""],
				zongfenshow:false,
        dankeshow:false,
        sel_xm:'',
        items: [],
        tmpitems:[],
        fields: [],
        tizus: [],
        dankescore: [],
        tmpdankescore: [],
        headVariant:'light',
        totalRows: 0,
        danketotalRows:0,
        currentPage: 1,
        perPage: 30,
        filter: null,
        filterOn: ['kh','nm','cl'],
        user_school:'',
        loading:false,
        filterName1:'', 
        filterName2:'',
            

		  };
		},
	
		mounted:function(){
			 
	
			  
		},

    activated() {

      this.getopt();//需要触发的函数

      },
          
	
		methods: {
      generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },
      exportdankedata() {
              const workbook = new ExcelJS.Workbook()
              const worksheet = workbook.addWorksheet(this.user_school)
              let xlshead=[]
              for (let i=0;i<this.tizus.length;i++)
              {
                let onedankeitem=this.tizus[i]['tihao']
                xlshead.push(onedankeitem)                
              }

              // 添加表头
              worksheet.addRow(xlshead)

              // 添加数据
              this.dankescore.forEach(onescore => {

              let onestscore=[]        

              for (let i=0;i<this.tizus.length;i++)
              {                 
               // onestscore.push(onescore[i])                
              }

                worksheet.addRow(onescore)
              })
              

              // 导出Excel文件
              workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                //自动列宽 begin
                for (let i = 0; i < worksheet.columns.length; i += 1) { 
                    let dataMax = 0;
                    const column = worksheet.columns[i];
                    for (let j = 1; j < column.values.length; j += 1) {
                      const columnLength = column.values[j].length;
                      if (columnLength > dataMax) {
                        dataMax = columnLength;
                      }
                    }
                    column.width = dataMax < 10 ? 10 : dataMax;
                  }
                 //自动列宽 end

                const filename = "导出" + ".xlsx";
               // saveAs(blob, filename);
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = this.sel_kemu+'.xlsx'
                link.click()
                window.URL.revokeObjectURL(url)
              })
            },
      //总分报表页
      zfbaobiao(){
              //1传递过去 班级列表 科目列表等 2报表页 获取相关数据   vue-html2pdf 生成报表页pdf 
              this.$router.push({ path: '/zfbaobiao', query: { xm: this.sel_xm,subject: this.sel_sb,tizu:this.sel_tizu }});	
            },
      exportzfdata() {
              const workbook = new ExcelJS.Workbook()
              const worksheet = workbook.addWorksheet(this.user_school)
              let xlshead=[]
              for (let i=0;i<this.fields.length;i++)
              {
                let onekemu=this.fields[i]['title']
                xlshead.push(onekemu)                
              }

              // 添加表头
              worksheet.addRow(xlshead)

              // 添加数据
              this.items.forEach(onescore => {

              let onestscore=[]
              onestscore.push(onescore.kh)
              onestscore.push(onescore.nm)
              onestscore.push(onescore.sc)
              onestscore.push(onescore.cl)
              onestscore.push(onescore.zf)

              for (let i=0;i<this.fields.length-5;i++)
              {                 
                onestscore.push(onescore[i])                
              }

                worksheet.addRow(onestscore)
              })
              

              // 导出Excel文件
              workbook.xlsx.writeBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                //自动列宽 begin
                for (let i = 0; i < worksheet.columns.length; i += 1) { 
                    let dataMax = 0;
                    const column = worksheet.columns[i];
                    for (let j = 1; j < column.values.length; j += 1) {
                      const columnLength = column.values[j].length;
                      if (columnLength > dataMax) {
                        dataMax = columnLength;
                      }
                    }
                    column.width = dataMax < 10 ? 10 : dataMax;
                  }
                 //自动列宽 end

                const filename = "导出" + ".xlsx";
               // saveAs(blob, filename);
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = '总成绩.xlsx'
                link.click()
                window.URL.revokeObjectURL(url)
              })
            },
		
      handleClick(tab, event) {
        console.log(tab, event)
        console.log(this.activeName)
        let selkemu=this.kemulist[this.activeName]
        this.sel_kemu=selkemu
        this.fields=[]
        this.items=[]
        this.tizus=[]
        this.dankescore=[]
        this.loading=true
        if (selkemu=='总分')
        {
          console.log('总分'+'成绩....')
          this.getSchooScore()	
          this.zongfenshow=true
          this.dankeshow=false		 
         

        }
        else
        {
          this.zongfenshow=false
          this.dankeshow=true	
          this.getSchooDanke()
         
        }
        //获取对应科目上传信息
      },
		 
			getopt(){		
				        	console.log('请求开始');
			 
                  this.sel_xm=localStorage.getItem('xm')
                  let kemul=localStorage.getItem('kemu')
                  this.kemulist=kemul.split(" ")
                  this.kemulist.unshift ('总分')
                 
                  let i=0;
                  for (i=0;i<this.kemulist.length-1;i++)
                  {
                    console.log(this.kemulist[i])
                  }									 
									
					  			console.log('请求结束')			
                  this.user_school=localStorage.getItem('user_school')
                  //获取总分 start
                  this.activeName=0
                  let selkemu=this.kemulist[this.activeName]
                  this.sel_kemu=selkemu
                  this.fields=[]
                  this.items=[]
                  this.tizus=[]
                  this.dankescore=[]
                  this.loading=true                  
                  this.getSchooScore()	
                  this.zongfenshow=true
                  this.dankeshow=false	  
                   //获取总分 end               
 
			},
      getSchooScore () {
      
         this.sel_School=''
         axios.post('/cjman?op=exameSchoolZf',qs.stringify({"xm":this.sel_xm,'school':this.sel_School})).then((res)=>{
              console.log(res)
              this.filter=null;
              this.fields=res.data.kemu;
              this.items=res.data.score;
              this.tmpitems=this.items
              this.totalRows = this.items.length;

              this.classList=res.data.class;
              let nuv={ value: null, text: '请选择班级' };
              this.classList.unshift(nuv);

              if (this.classList.length>=1)
              {
                this.isshow=true;
              }
              console.log(res.data.class);
              this.loading=false
              
          }).catch((res)=>{
              console.log(response)
          })
    },

    getSchooDanke() {
      
      let xm=this.sel_xm
      let grade=xm.substring(xm.indexOf('(')+1,xm.indexOf(')'))
      console.log('年级:'+grade);	

      this.sel_School=''
      axios.post('/cjman?op=exameSchoolDanke',qs.stringify({"xm":this.sel_xm,'kemu':this.sel_kemu,'grade':grade})).then((res)=>{
           console.log(res)
           this.filter=null
           this.tizus=res.data.tizu
           this.dankescore=res.data.dankescore
           this.tmpdankescore=this.dankescore
           this.danketotalRows= this.dankescore.length;
           console.log(res.data.tizu)
           console.log(res.data.dankescore)
           this.loading=false
           
       }).catch((res)=>{
           console.log(response)
       })
 },
 searchEvent1 () {
              const filterName = XEUtils.toValueString(this.filterName1).trim().toLowerCase()
              if (filterName) {
                const filterRE = new RegExp(filterName, 'gi')
                const searchProps = ['0', '1']
                const rest = this.tmpdankescore.filter(item => searchProps.some(key => XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1))
                this.dankescore = rest.map(row => {
                  const item = Object.assign({}, row)
                  searchProps.forEach(key => {
                    item[key] = XEUtils.toValueString(item[key]).replace(filterRE, match => `${match}`)
                  })
                  return item
                })
                this.danketotalRows=this.dankescore.length
              } else {
                this.dankescore = this.tmpdankescore
                this.danketotalRows=this.dankescore.length
              }
        },
    searchEvent2 () {
              const filterName = XEUtils.toValueString(this.filterName2).trim().toLowerCase()
              if (filterName) {
                const filterRE = new RegExp(filterName, 'gi')
                const searchProps = ['kh', 'nm']
                const rest = this.tmpitems.filter(item => searchProps.some(key => XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1))
                this.items = rest.map(row => {
                  const item = Object.assign({}, row)
                  searchProps.forEach(key => {
                    item[key] = XEUtils.toValueString(item[key]).replace(filterRE, match => `${match}`)
                  })
                  return item
                })
                this.totalRows=this.items.length
              } else {
                this.items = this.tmpitems
                this.totalRows=this.items.length
              }
        },


      getuploadsc(){				 
			 
                  
                  this.sel_xm=localStorage.getItem('xm')
                  let selindex=Number(this.activeName);
                  let kemu=this.kemulist[selindex]
                 
                  this.$http.get('/scoreman?op=selServerXm').then(function(res){
                
                          console.log(res.data);
                          this.xmlist=res.data;
                          console.log('请求结束');
              
                  },function(){
                    console.log('请求失败处理');
                  });

									
					  	 				 
			},
	
 
	
		}
	  };
	</script>
	